import ResourcesCollectionProto from "./resources-collection-proto"
import Task from "../../model2/task/task"
import Resources from "../resources";
import TimeReportsCollection from "../../model2/time-report/collection";

export default class TasksResourcesCollection extends ResourcesCollectionProto {
    constructor(resources:Resources, data: any[] = [], options:any = {}) {
        super(resources, data, Task, options)
    }

    resetTimeReports() {
        _.map(this.models, (task:Task)=>{
            task.timeReports.reset()
        })
    }

    linkTimeReports(timeReportsCollection: TimeReportsCollection | null) {

        if (!TimeReportsCollection) return

        // @ts-ignore
        _.map(timeReportsCollection.models, (timeReport)=>{

            let task

            // patch
            if (timeReport.taskId) {
                task = this.get(timeReport.taskId)
            }

            if (timeReport.task?.id) {
                task = this.get(timeReport.task.id)
            }

            if (task) {
                task.timeReports.add(timeReport)
            }

        })
    }

}